import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { ArticleState } from './types';
import { RootState } from '@/store/types';

export const state: ArticleState = {
    activeArticleId: null,
    activePriceListId: null,
    articles: [],
    priceLists: [],
    warehouses: [],
    categories: [],
    filters: {},
};
const namespaced: boolean = true;

export const article: Module<ArticleState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
